

export var GlobalVariables = {
    // Software version
    softwareVersion: '1.0',
    // Firebase auth
    firebaseAuth: {
        invalidCredentials: 'auth/invalid-credential',
        passwordPolicyRequirements: 'auth/password-does-not-meet-requirements',
    },
    // Cloud storage 
    firestorage : {
        rootDirectoryName_Dicom: 'dcm',
        rootDirectoryName_UploadingTest: 'uploadingTest'
    }, 
    // Process for uploading the images to the backend
    dcmImagesUploading: {
        // Manages the dcm inspection when patient_id, study_uid and series_uid has been delete
        'allowBadlyAnonimizedDcm': true,
        'badlyAnonymizedId': 'delete',
        // Determines if more than one image can be selected for classification
        'singleSliceSelection': false,
        // Positioning image generation speedup
        'largestJump': 8,
        'minSliceSpacing': 2,
    },  
    // Additional data poups
    additionalDataPopups: {
        vertebralLevels: {
            vertebralLevelsNameList: ['Occipital-C1', 'C1-C2', 'C2-C3', 'C3-C4', 'C4-C5', 'C5-C6', 'C6-C7', 'C7-T1',
            'T1-T2', 'T2-T3', 'T3-T4', 'T4-T5', 'T5-T6', 'T6-T7', 'T7-T8', 'T8-T9', 'T9-T10',
            'T10-T11', 'T11-T12', 'T12-L1', 'L1-L2', 'L2-L3', 'L3-L4', 'L4-L5', 'L5-Sacro'],
            ivContrastLevelValueList: [[1, 0], [0.75, 0.25], [0.5, 0.5], [0.25, 0.75], [0, 1]]
        },
        maxValue_imageQuality: 3,
        maxValue_segmentationDifficulty: 2,
        maxValue_patientOrientation: 3,
        maxValue_nArtifactRanges: 5,
        maxValue_nOverflowRanges: 5,
        patientOrientationValueList: ['Face up', 'Face right', 'Face down', 'Face left'],
        imageQualityValueList: ['Useless', 'Low quality', 'Average quality', 'High quality'],
        segmentationDifficultyValueList: ['Easy', 'Medium difficulty', 'Difficult'],
    },
    // Processes variables
    processes: {
        // Vertebral levels
        vertebralLevels: {
            uploadImageOffset: 10, // Number of additional slices uploaded for results (before and after the selected ones)
        },
    }
}


